import { useMemo } from 'react';
import { useAppSelector } from './useAppSelector';
import { useSelectedCampaign } from './useSelectedCampaign';

const defaultDomainBackendPrice = 5000000;

export const usePropertyPriceSelector = () => {
  const {
    formValues: { BackendPrice, EstimatedSellingPrice },
  } = useAppSelector(state => state.form);

  const { selectedCampaign } = useSelectedCampaign();

  const relevantPriceRange = useMemo(
    () => EstimatedSellingPrice ?? BackendPrice,
    [EstimatedSellingPrice, BackendPrice]
  );

  const propertyPrice = useMemo(() => {
    let price: number | null = defaultDomainBackendPrice;

    if (relevantPriceRange != null) {
      const backendPriceToBeConfirmed =
        relevantPriceRange?.toBeConfirmed ?? false;

      if (!backendPriceToBeConfirmed) {
        if (relevantPriceRange?.priceRange != null) {
          const { upperRange, lowerRange } = relevantPriceRange.priceRange;
          price = upperRange ?? lowerRange;
        } else if (selectedCampaign?.backendPriceRange) {
          const { upperRange, lowerRange } = selectedCampaign.backendPriceRange;
          price = upperRange ?? lowerRange;
        }
      }
    }

    if (price == null || Number.isNaN(Number(price))) {
      price = defaultDomainBackendPrice;
    }

    return price;
  }, [relevantPriceRange, selectedCampaign]);

  return propertyPrice;
};
